import { PersonSupplementaryInsuranceState } from '../states/offer/offer.state';
import { mapBasicTexts } from './supplementary-insurance-product-configuration-mappers/basic';
import {
  mapHospitalTexts,
  mapHospitalVivaTexts,
} from './supplementary-insurance-product-configuration-mappers/hospital';
import { mapComplementaryTexts } from './supplementary-insurance-product-configuration-mappers/complementary';
import { mapOutpatientTexts } from './supplementary-insurance-product-configuration-mappers/outpatient';
import { mapHospitalCapitalTexts } from './supplementary-insurance-product-configuration-mappers/hospitalCapital';
import { mapAccidentDeathCapitalTexts } from './supplementary-insurance-product-configuration-mappers/accidentDeathCapital';
import { mapAccidentDisabilityCapitalTexts } from './supplementary-insurance-product-configuration-mappers/accidentDisabilityCapital';
import { mapSicknessDeathOrDisabilityCapitalTexts } from './supplementary-insurance-product-configuration-mappers/sicknessDeathOrDisabilityCapital';
import { mapLegalProtectionTexts } from './supplementary-insurance-product-configuration-mappers/legalProtection';
import { mapDentalTexts } from './supplementary-insurance-product-configuration-mappers/dental';
import { mapHospitalDailyCashTexts } from './supplementary-insurance-product-configuration-mappers/hospitalDailyCash';
import { mapDailyCashTexts } from './supplementary-insurance-product-configuration-mappers/dailyCash';
import { ParseableAmount } from '../services/translate-with-amount.service';
import { mapEmergencyCareTexts } from './supplementary-insurance-product-configuration-mappers/emergencyCare';
import { mapAccidentMedicalExpensesSupplementTexts } from './supplementary-insurance-product-configuration-mappers/accidentMedicalExpensesSupplement';
import { mapOutpatientVivaTexts } from './supplementary-insurance-product-configuration-mappers/outpatientViva';
import { mapComplementaryVivaTexts } from './supplementary-insurance-product-configuration-mappers/complementaryViva';

export interface ProductConfig {
  key: string;
  amount?: ParseableAmount;
}

export interface SupplementaryInsuranceConfigurationTexts {
  productKey: string;
  productConfig: ProductConfig[];
  infoTextKey?: string;
}

export const supplementaryInsuranceConfigurationTextMap: {
  [key in keyof PersonSupplementaryInsuranceState]-?: (
    insurance: PersonSupplementaryInsuranceState,
  ) => SupplementaryInsuranceConfigurationTexts;
} = {
  basic: mapBasicTexts,
  hospital: mapHospitalTexts,
  hospitalViva: mapHospitalVivaTexts,
  complementary: mapComplementaryTexts,
  complementaryViva: mapComplementaryVivaTexts,
  outpatient: mapOutpatientTexts,
  outpatientViva: mapOutpatientVivaTexts,
  hospitalCapital: mapHospitalCapitalTexts,
  accidentDeathCapital: mapAccidentDeathCapitalTexts,
  accidentDisabilityCapital: mapAccidentDisabilityCapitalTexts,
  sicknessDeathOrDisabilityCapital: mapSicknessDeathOrDisabilityCapitalTexts,
  legalProtection: mapLegalProtectionTexts,
  dental: mapDentalTexts,
  hospitalDailyCash: mapHospitalDailyCashTexts,
  dailyCash: mapDailyCashTexts,
  emergencyCare: mapEmergencyCareTexts,
  accidentMedicalExpensesSupplement: mapAccidentMedicalExpensesSupplementTexts,
};
